function e(e){return e&&e.ownerDocument||document}export{e as default};
//# sourceMappingURL=ownerDocument.js.map
